module.exports = __webpack_public_path__ + "img/title-en.d283ccf1.png";